<template>
  <div class="cgs-app-appPage" :class="theme">
    <div class="cgs-appPage-header">
      <van-nav-bar :border="false">
        <template #left>
          <span class="iconfont cgsIcon-houtui" @click="goBack"></span>
        </template>
        <template #right>
          <van-popover v-model="showMoreTool" trigger="click" placement="bottom-end" :actions="actions"
            @select="selectedMore">
            <template #reference>
              <span class="iconfont cgsIcon-gengduocaozuo"></span>
            </template>
          </van-popover>
        </template>
      </van-nav-bar>
      <div class="cgs-appPage-title">
        <span :class="[logoIconFontFamily, logoIconProfix + icon]"></span>
        <span class="cgs-appPage-title-name">{{ title }}</span>
      </div>
    </div>

    <van-pull-refresh v-model="wholeLoading" @refresh="onRefresh">
      <div class="cgs-appPage-content">
        <van-collapse v-model="activeNames" :border="false" class="stagingCollapse">
          <van-collapse-item :title="group.name" :name="group.id" v-for="group in worksheetGroupList" :key="group.id"
            v-show="group.worksheetInfoList.length !== 0">
            <div v-for="worksheet in group.worksheetInfoList" :key="worksheet.id">
              <van-cell :title="worksheet.name" :clickable="true" v-if="!worksheet.hidden || worksheet.owner === userId"
                @click="clickWorkSheet(worksheet)">
                <template #icon>
                  <span class="cgsIcon-worksheet cgs-appPage-header-worksheet-icon" :class="[
                    logoIconFontFamily,
                    logoIconProfix +
                    (worksheet.icon
                      ? worksheet.icon
                      : worksheetDefaultLogoIcon),
                  ]" style="margin-right: 15px"></span>
                </template>
              </van-cell>
            </div>
          </van-collapse-item>
        </van-collapse>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
  import {
    NavBar,
    PullRefresh,
    Collapse,
    CollapseItem,
    Cell,
    Popover,
  } from "vant";
  import {
    getAppList,
    getAppAuth
  } from "@/api/application";
  import {
    font_family,
    profix,
    defaultIcon_app,
    defaultIcon_worksheet,
  } from "@/util/LOGO_ICON_CONFIG";
  import {
    getUserAuthority
  } from "@/util/author";
  export default {
    components: {
      vanNavBar: NavBar,
      vanCollapse: Collapse,
      vanCollapseItem: CollapseItem,
      vanPullRefresh: PullRefresh,
      vanCollapse: Collapse,
      vanCollapseItem: CollapseItem,
      vanCell: Cell,
      vanPopover: Popover,
    },
    data() {
      return {
        wholeLoading: false,
        showMoreTool: false,
        logoIconProfix: profix,
        logoIconFontFamily: font_family,
        appDefaultLogoIcon: defaultIcon_app,
        worksheetDefaultLogoIcon: defaultIcon_worksheet,
        activeNames: [],
        appDetail: {},
        manageable: false,
        actions: [{
          text: "编辑应用",
          id: "editApp"
        }],
      };
    },
    mounted() {
      this.init();
    },
    computed: {
      userId: {
        get() {
          let userAuthority = getUserAuthority();
          return userAuthority.userId;
        },
        set() {},
      },
      appId: {
        get() {
          return this.$route.params.appId;
        },
        set() {},
      },
      worksheetGroupList: {
        get() {
          return this.appDetail.worksheetGroupList;
        },
        set() {},
      },
      title: {
        get() {
          return this.appDetail.title;
        },
        set() {},
      },
      icon: {
        get() {
          return this.appDetail.icon ?
            this.appDetail.icon :
            this.appDefaultLogoIcon;
        },
        set() {},
      },
      theme: {
        get() {
          return this.appDetail.theme ? this.appDetail.theme : "defaultTheme";
        },
        set() {},
      },
    },
    watch: {
      worksheetGroupList() {
        this.activeNames = this.worksheetGroupList.map((group) => group.id);
      },
    },
    methods: {
      async init() {
        this.wholeLoading = true;
        try {
          let result = await getAppList(this.appId);
          this.appDetail = result.data;
          if (this.appId) {
            let appAuthResult = await getAppAuth(this.appId);
            let appAuth = appAuthResult.data;
            this.setRowAuth(appAuth);
          }
        } catch (e) {
          console.error(e);
        } finally {
          this.wholeLoading = false;
        }
      },
      goBack() {
        this.$router.go(-1);
      },
      onRefresh() {
        this.init();
      },
      clickWorkSheet(worksheet) {
        this.$router.push({
          path: `/worksheet/${worksheet.id}`
        });
      },
      showMore() {
        this.showMoreTool = true;
      },
      selectedMore(action) {
        switch (action.id) {
          case "editApp":
            if (this.manageable) {
              this.$router.push({
                path: `/editApp/${this.appId}`
              });
            } else {
              this.$Notify({
                type: "danger",
                message: "没有权限,请联系相关人员"
              });
            }
        }
      },

      setRowAuth(appAuthObj) {
        let appAuth = appAuthObj['appAuth']
        if (appAuth.includes("MANAGE_APP_AUTH")) {
          this.manageable = true;
          return;
        }
      },
    },
  };
</script>

<style scoped>
  .cgs-app-appPage {
    background: #f5f5f5;
    display: flex;
    flex-direction: column;
  }

  .cgs-appPage-header {
    color: #fff;
  }

  .cgs-appPage-title {
    padding: 20px 10px 20px 10px;
    display: flex;
    flex-direction: row;
  }

  .cgs-appPage-title-name {
    margin-left: 10px;
    display: block;
    flex-grow: 1;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .cgs-appPage-content {
    flex-grow: 1;
  }
</style>
<style>
  .cgs-appPage-header .van-nav-bar {
    background-color: transparent;
  }

  .cgs-appPage-header .van-nav-bar__title {
    color: #fff;
  }

  .cgs-app-appPage .van-collapse-item__content .van-cell {
    padding: 10px 0px;
  }

  .cgs-app-appPage .van-collapse-item__title--expanded.van-cell::after {
    border-bottom: unset !important;
  }

  .cgs-app-appPage .van-collapse-item {
    margin-bottom: 10px;
  }
</style>
<style lang="less">
  @import "../../assets/style/less/application.less";

  .theme1 {
    .applicationTheme(rgba(255, 185, 0, 1), rgba(255, 185, 0, 0.2));
  }

  .theme2 {
    .applicationTheme(rgba(255, 140, 0, 1), rgba(255, 140, 0, 0.2));
  }

  .theme3 {
    .applicationTheme(rgba(247, 99, 12, 1), rgba(247, 99, 12, 0.2));
  }

  .theme4 {
    .applicationTheme(rgba(202, 80, 16, 1), rgba(202, 80, 16, 0.2));
  }

  .theme5 {
    .applicationTheme(rgba(218, 59, 1, 1), rgba(218, 59, 1, 0.2));
  }

  .theme6 {
    .applicationTheme(rgba(239, 105, 80, 1), rgba(239, 105, 80, 0.2));
  }

  .theme7 {
    .applicationTheme(rgba(209, 52, 56, 1), rgba(209, 52, 56, 0.2));
  }

  .theme8 {
    .applicationTheme(rgba(255, 67, 67, 1), rgba(255, 67, 67, 0.2));
  }

  .theme9 {
    .applicationTheme(rgba(231, 72, 86, 1), rgba(231, 72, 86, 0.2));
  }

  .theme10 {
    .applicationTheme(rgba(232, 17, 35, 1), rgba(232, 17, 35, 0.2));
  }

  .theme11 {
    .applicationTheme(rgba(234, 0, 94, 1), rgba(234, 0, 94, 0.2));
  }

  .theme12 {
    .applicationTheme(rgba(195, 0, 82, 1), rgba(195, 0, 82, 0.2));
  }

  .theme13 {
    .applicationTheme(rgba(227, 0, 140, 1), rgba(227, 0, 140, 0.2));
  }

  .theme14 {
    .applicationTheme(rgba(191, 0, 119, 1), rgba(191, 0, 119, 0.2));
  }

  .theme15 {
    .applicationTheme(rgba(194, 57, 179, 1), rgba(194, 57, 179, 0.2));
  }

  .theme16 {
    .applicationTheme(rgba(154, 0, 137, 1), rgba(154, 0, 137, 0.2));
  }

  .theme17 {
    .applicationTheme(rgba(0, 120, 215, 1), rgba(0, 120, 215, 0.2));
  }

  .theme18 {
    .applicationTheme(rgba(0, 99, 177, 1), rgba(0, 99, 177, 0.2));
  }

  .theme19 {
    .applicationTheme(rgba(142, 140, 216, 1), rgba(142, 140, 216, 0.2));
  }

  .theme20 {
    .applicationTheme(rgba(107, 105, 214, 1), rgba(107, 105, 214, 0.2));
  }

  .theme21 {
    .applicationTheme(rgba(135, 100, 184, 1), rgba(135, 100, 184, 0.2));
  }

  .theme22 {
    .applicationTheme(rgba(116, 77, 169, 1), rgba(116, 77, 169, 0.2));
  }

  .theme23 {
    .applicationTheme(rgba(177, 70, 194, 1), rgba(177, 70, 194, 0.2));
  }

  .theme24 {
    .applicationTheme(rgba(136, 23, 152, 1), rgba(136, 23, 152, 0.2));
  }

  .defaultTheme {
    .applicationTheme(rgba(0, 153, 188, 1), rgba(0, 153, 188, 0.2));
  }

  .theme26 {
    .applicationTheme(rgba(45, 125, 154, 1), rgba(45, 125, 154, 0.2));
  }

  .theme27 {
    .applicationTheme(rgba(0, 183, 195, 1), rgba(0, 183, 195, 0.2));
  }

  .theme28 {
    .applicationTheme(rgba(3, 131, 135, 1), rgba(3, 131, 135, 0.2));
  }

  .theme29 {
    .applicationTheme(rgba(0, 178, 148, 1), rgba(0, 178, 148, 0.2));
  }

  .theme30 {
    .applicationTheme(rgba(1, 133, 116, 1), rgba(1, 133, 116, 0.2));
  }

  .theme31 {
    .applicationTheme(rgba(0, 204, 106, 1), rgba(0, 204, 106, 0.2));
  }

  .theme32 {
    .applicationTheme(rgba(16, 137, 62, 1), rgba(16, 137, 62, 0.2));
  }

  .theme33 {
    .applicationTheme(rgba(122, 117, 116, 1), rgba(122, 117, 116, 0.2));
  }

  .theme34 {
    .applicationTheme(rgba(93, 90, 88, 1), rgba(93, 90, 88, 0.2));
  }

  .theme35 {
    .applicationTheme(rgba(104, 118, 138, 1), rgba(104, 118, 138, 0.2));
  }

  .theme36 {
    .applicationTheme(rgba(81, 92, 107, 1), rgba(81, 92, 107, 0.2));
  }

  .theme37 {
    .applicationTheme(rgba(86, 124, 115, 1), rgba(86, 124, 115, 0.2));
  }

  .theme38 {
    .applicationTheme(rgba(72, 104, 96, 1), rgba(72, 104, 96, 0.2));
  }

  .theme39 {
    .applicationTheme(rgba(73, 130, 5, 1), rgba(73, 130, 5, 0.2));
  }

  .theme40 {
    .applicationTheme(rgba(16, 124, 16, 1), rgba(16, 124, 16, 0.2));
  }

  .theme41 {
    .applicationTheme(rgba(118, 118, 118, 1), rgba(118, 118, 118, 0.2));
  }

  .theme42 {
    .applicationTheme(rgba(76, 74, 72, 1), rgba(76, 74, 72, 0.2));
  }

  .theme43 {
    .applicationTheme(rgba(105, 121, 126, 1), rgba(105, 121, 126, 0.2));
  }

  .theme44 {
    .applicationTheme(rgba(74, 84, 89, 1), rgba(74, 84, 89, 0.2));
  }

  .theme45 {
    .applicationTheme(rgba(100, 124, 100, 1), rgba(100, 124, 100, 0.2));
  }

  .theme46 {
    .applicationTheme(rgba(82, 94, 84, 1), rgba(82, 94, 84, 0.2));
  }

  .theme47 {
    .applicationTheme(rgba(132, 117, 69, 1), rgba(132, 117, 69, 0.2));
  }

  .theme48 {
    .applicationTheme(rgba(126, 115, 95, 1), rgba(126, 115, 95, 0.2));
  }
</style>